import { replaceUrlPlaceholders } from "react-utils";
import axiosCoralie from "../axios-setup";

const CONF = window?.confPub;
const DEMANDE_ACIT_ROUTES = CONF?.ROUTES?.DEMANDE_ACIT

export const getRemboursements = async (numContrat, numPersonne, codeFamille) => {

    const GET_INDEMNISATIONS = DEMANDE_ACIT_ROUTES?.GET_INDEMNISATIONS

    const query = `?numContrat=${ numContrat }&numPersonne=${ numPersonne }&codeFamille=${ codeFamille }`

    try {
        const resp = await axiosCoralie.get(GET_INDEMNISATIONS + query)

        console.log("resp")
        console.log(resp)

        if (resp?.data?.length > 0) {
            return resp?.data
        } else {
            return []
        }

    } catch (err) {

        console.error('Erreur lors de l\'envoi des données', err);
        // alert('Échec de l\'envoi des données');
        throw err;
    }
}

export const getDemandeAcit = async (idCorrespondant, idBeneficiaire) => {

    const GET_DEMANDE = DEMANDE_ACIT_ROUTES?.GET_DEMANDE
    const urlWithIds = replaceUrlPlaceholders(GET_DEMANDE,
        { idCorrespondant: idCorrespondant, idBeneficiaire: idBeneficiaire })

    console.log("urlWithIds")
    console.log(urlWithIds)

    try {
        const resp = await axiosCoralie.get(urlWithIds)

        if (resp?.data?.demandesACITType.length > 0) {
            return resp?.data?.demandesACITType
        } else {
            return []
        }

    } catch (err) {

        console.error('Erreur lors de l\'envoi des données', err);
        // alert('Échec de l\'envoi des données');
        throw err;
    }
}

// TODO vérifier
export const envoiFormulaireAcit = async (formulaire) => {

    try {
        const resp = await axiosCoralie.post(DEMANDE_ACIT_ROUTES?.ENVOI_DEMANDE, formulaire)

        console.log("resp")
        console.log(resp)

        if (resp?.data?.code) {

            throw new Error("Echec de l'envoi")
        } else {

            return resp?.data
        }

    } catch (err) {

        console.error('Erreur lors de l\'envoi des données', err);
        // alert('Échec de l\'envoi des données');
        throw err;
    }
}

export const envoiPjsAcit = async (demandeUuid, pieceJointe) => {

    const ENVOI_PJ = DEMANDE_ACIT_ROUTES?.ENVOI_PJ
    const urlWithDemandeUuid = replaceUrlPlaceholders(ENVOI_PJ,
        { demandeUuid: demandeUuid })

    try {
        const resp = await axiosCoralie.post(urlWithDemandeUuid, pieceJointe)

        if (resp?.data?.code) {

            throw new Error("Echec de l'envoi de pièce jointe")
        } else {

            return resp?.data
        }

    } catch (err) {

        console.error('Erreur lors de l\'envoi des données', err);
        // alert('Échec de l\'envoi des données');
        throw err;
    }
}

export const envoiDemandeEditique = async (demandeUuid, idUniqueGrc) => {

    const ENVOI_DEMANDE_EDITIQUE = DEMANDE_ACIT_ROUTES?.ENVOI_DEMANDE_EDITIQUE
    const urlWithDemandeUuid = replaceUrlPlaceholders(ENVOI_DEMANDE_EDITIQUE,
        { demandeUuid: demandeUuid })

    try {
        const resp = await axiosCoralie.post(urlWithDemandeUuid)

        if (resp?.data?.code || resp?.data?.message) {

            throw new Error("Echec de l'envoi de la demande éditique")
        } else {

            return resp?.data
        }

    } catch (err) {

        console.error('Erreur lors de l\'envoi des données', err);
        // alert('Échec de l\'envoi des données');
        throw err;
    }
}